import styles from "@/pages/callTool/intelligentOutboundCall/index.module.less";
import {STitle} from "shj-components";
import {Button, Col, Empty, Row, Tooltip} from "antd";
import React, {useCallback, useContext, useEffect} from "react";
import {isArray, isEmpty} from "lodash-es";
import clueDetailContext from "@/pages/callTool/intelligentOutboundCall/components/Info/clueDetailContext.ts";
import {useSetState} from "ahooks";
import {getClueButton} from "@/services/saleOpServices.ts";
import SaleModal from "@/pages/saleOperations/saleWorkBench/customerDetail/components/saleModal";
import {useAtom} from "jotai";
import {callListAtom} from "@/pages/callTool/intelligentOutboundCall/components/Info/store";

enum TaskKey {
  CALL_PENDING = 'CALL_PENDING', // 呼叫待定
  CALL_VALID = 'CALL_VALID', // 呼叫有效
  CALL_INVALID = 'CALL_INVALID', // 呼叫无效
  APPOINT_DISPATCH = 'APPOINT_DISPATCH', // 指定派单
  DISPATCH = 'DISPATCH', // 派单
  CALL_APPOINTMENT = 'CALL_APPOINTMENT', // 云客服邀约
}

export const ClueInfoAddOper = () => {
  const {detailInfo} = useContext(clueDetailContext)
  const [callList, setCallList] = useAtom(callListAtom)
  const [state, setState] = useSetState({
    loading: false,
    buttons: [],
    chooseButtonKey: '',
    [TaskKey.APPOINT_DISPATCH.toLowerCase()]: false,
  })

  useEffect(() => {
    if (detailInfo.id) {
      getButtons()
    }
  }, [detailInfo.id]);

  const reload = () => {
    setCallList({...callList, reload: !callList.reload})
  }

  const getButtons = () => {
    setState({loading: true})
    getClueButton(detailInfo.id).then(res => {
      setState({buttons: res.filter(item => item.buttonKey !== 'DIALING')})
    }).catch(() => setState({loading: false}))
  }

  const dtlForms = [
    {name: ['houseInfo', 'channelName'], label: '客户来源', span: 8},
    {name: ['channelClue', 'cityName'], label: '报名城市', span: 8},
    {name: ['houseInfo', 'buildingName'], label: '楼盘名称', span: 8},
    {name: ['houseInfo', 'constructArea'], label: '建筑面积', span: 8},
    {name: ['houseInfo', 'innerArea'], label: '套内面积', span: 8},
    {name: ['dtlInfo', 'bizTypeNames'], label: '客户需求标签', span: 8},
    {name: 'remark', label: '备注', span: 24},
  ]

  const dtlEle = useCallback((item) => {
    if (!isEmpty(detailInfo)) {
      const detail = detailInfo;
      let value = ''
      if (isArray(item.name)) {
        value = item.name.reduce((res, item) => {
          res = detail[item] || res[item]
          return res;
        }, {})
      } else {
        value = detail[item.name]
      }
      return <Col span={item.span || 8} className={styles.colBox}>
        <span className={styles.label}>{item.label}：</span>
        <span className={styles.value}><Tooltip title={value}>{value}</Tooltip></span>
      </Col>
    }
  }, [detailInfo])

  return <div className={styles.dtlBox}>
    <div className={state.buttons?.length ? styles.btns : styles.noBtns}>
      {state.buttons?.map(btn => {
        return <>
          <div className={styles.buttonList}>
            <SaleModal
                useBtnKey={true}
                disabledAuth={true}
                detailState={detailInfo}
                trackDetail={{}}
                reload={reload}
                state={state}
                setState={setState}
                buttonList={[btn]}
            >
            </SaleModal>
          </div>
        </>
      })}
    </div>
    <STitle title={'线索信息'}/>
    {isEmpty(detailInfo) ?  <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}/> :
        <Row gutter={10} className={styles.rowBox}>
          {dtlForms?.map(item => {
            return dtlEle(item)
          })}</Row>}
  </div>
}